module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    class: {
      white: _vm.whiteHeader
    },
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "grid-noBottom"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('router-link', {
    staticClass: "home",
    attrs: {
      "to": {
        name: 'home'
      }
    },
    nativeOn: {
      "click": function($event) {
        _vm.setHomeState($event)
      }
    }
  }, [_c('h2', {
    staticClass: "h-l lh-8"
  }, [_vm._v("California "), _c('br'), _vm._v("\nAfrican American "), _c('br'), _vm._v("\nMuseum")]), _c('div', {
    staticClass: "header-logo"
  }, [(!_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo_white.svg"
    }
  }) : _vm._e(), (_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/logos/caam_logo.svg"
    }
  }) : _vm._e()], 1)])], 1)]), _c('nav', [_c('button', {
    staticClass: "h-l ag bold menu-button",
    class: {
      active: _vm.menu, white: _vm.whiteHeader
    },
    attrs: {
      "aria-label": _vm.ariaMenu
    },
    on: {
      "click": _vm.showNav
    }
  }, [_vm._v(_vm._s(_vm.menuText))]), (!_vm.menu) ? _c('div', {
    staticClass: "hamburger",
    class: {
      active: _vm.menu
    },
    on: {
      "click": _vm.showNav
    }
  }, [(!_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/hamburger.svg"
    }
  }) : _vm._e(), (_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/hamburger_black.svg"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.menu) ? _c('div', {
    staticClass: "x",
    class: {
      active: _vm.menu
    },
    on: {
      "click": _vm.showNav
    }
  }, [(_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/x_out_white.svg"
    }
  }) : _vm._e(), (!_vm.whiteHeader) ? _c('visual', {
    attrs: {
      "image": "/static/icons/x_out_black.svg"
    }
  }) : _vm._e()], 1) : _vm._e(), (_vm.searchIcon()) ? _c('button', {
    staticClass: "icon",
    attrs: {
      "aria-label": "Open search by pressing enter or clicking.",
      "role": "button"
    },
    on: {
      "click": _vm.showSearchOnly
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/search_white.svg",
      "width": "3rem"
    }
  })], 1) : _vm._e(), (!_vm.searchIcon()) ? _c('button', {
    staticClass: "icon",
    attrs: {
      "href": "",
      "aria-label": "open search",
      "role": "button"
    },
    on: {
      "click": _vm.showSearchOnly
    }
  }, [_c('visual', {
    attrs: {
      "image": "/static/icons/search_black.svg",
      "width": "3rem"
    }
  })], 1) : _vm._e(), (!_vm.loading) ? _c('ul', {
    class: {
      active: _vm.menu, white: !_vm.whiteHeader, black: _vm.whiteHeader
    }
  }, [_vm._l((_vm.loadedData.root), function(item) {
    return (!_vm.searchOnly) ? _c('li', [_c('router-link', {
      staticClass: "bold l-l",
      class: item.uid + '-link',
      attrs: {
        "to": {
          name: item.uid
        }
      },
      nativeOn: {
        "mouseover": function($event) {
          _vm.showChildren(item.uid, $event)
        }
      }
    }, [_vm._v(_vm._s(item.title))]), (_vm.active === item.uid) ? _c('ul', {
      staticClass: "d-o"
    }, _vm._l((item.children), function(child) {
      return _c('li', [((item.uid !== 'exhibitions' && item.uid !== 'programs' && item.uid !== 'learn' && item.uid !== 'about')) ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-page"),
            params: {
              id: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'exhibitions' && _vm.formatRoute(child.uid) !== 'current') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-overview"),
            params: {
              year: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'exhibitions' && _vm.formatRoute(child.uid) === 'current') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ("" + (item.uid))
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e(), (item.uid === 'programs') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-overview"),
            params: {
              category: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(_vm.formatProgramChildren(child.title.toLowerCase())))]) : _vm._e(), (item.uid === 'learn' && child.uid === '600state') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: 'blog'
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : (item.uid === 'learn' && child.uid !== '600state') ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-page"),
            params: {
              id: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid !== 'subscribe')) ? _c('router-link', {
        staticClass: "bold l-sm",
        attrs: {
          "to": {
            name: ((item.uid) + "-page"),
            params: {
              id: _vm.formatRoute(child.uid)
            }
          }
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : ((item.uid === 'about' && child.uid === 'subscribe')) ? _c('h3', {
        on: {
          "click": _vm.subscribe
        }
      }, [_vm._v(_vm._s(child.title.toLowerCase()))]) : _vm._e()], 1)
    })) : _vm._e()], 1) : _vm._e()
  }), _c('li', [_c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.search) ? _c('ul', {
    staticClass: "search",
    class: {
      black: _vm.whiteHeader
    }
  }, [_c('li', [_c('form', {
    attrs: {
      "onsubmit": "return false"
    }
  }, [_c('label', {
    staticClass: "dn",
    attrs: {
      "for": "searchterm"
    }
  }, [_vm._v("Search Query")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.query),
      expression: "query"
    }],
    attrs: {
      "type": "text",
      "name": "searchterm",
      "title": "Search Query"
    },
    domProps: {
      "value": (_vm.query)
    },
    on: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13)) { return null; }
        _vm.submit($event)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.query = $event.target.value
      }
    }
  })])]), _c('li', [_c('h4', {
    attrs: {
      "role": "button",
      "aria-label": "Submit search."
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("just ask.")])])]) : _vm._e()])], 1)], 2) : _vm._e()]), (_vm.bannerLoaded) ? _c('div', {
    staticClass: "banner"
  }, [_c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.bannerText)
    }
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-043f08f3"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TopNav.vue
// module id = 223
// module chunks = 1